import { apiAxios } from './axiosInstance';

// POST /api/invoices/{invoiceId}/payment-status — billing-contract.md §2.1.
// Best-effort UI sync called after a client-side confirmCardPayment/confirmCardSetup
// succeeds. The Stripe webhook remains the authoritative source of paid state; a
// failure here must never be treated as proof the payment failed.
export const postPaymentStatus = async (invoiceId, { paymentMethodId, status, type, consent } = {}) => {
  const payload = {
    payment_method_id: paymentMethodId,
    status,
    type,
  };
  if (consent) {
    payload.consent_authorized = true;
    payload.consent_authorized_at = consent.authorizedAt;
  }
  const response = await apiAxios.post(`/invoices/${invoiceId}/payment-status`, payload);
  return response.data;
};

// POST /api/invoices/client/{invoiceId}/pay-with-saved-card
// Quick-pay an invoice with a card already on file. Returns
// { status, clientSecret, paymentIntentId, requiresAction }. When requiresAction
// is true the caller must complete SCA with stripe.confirmCardPayment(clientSecret).
// The Stripe webhook remains authoritative for PAID state.
export const payInvoiceWithSavedCard = async (invoiceId, paymentMethodId) => {
  const response = await apiAxios.post(
    `/invoices/client/${invoiceId}/pay-with-saved-card`,
    { payment_method_id: paymentMethodId }
  );
  return response.data;
};

const consentStorageKey = (invoiceId) => `docusigner:subscription-consent:${invoiceId}`;

// Client-side audit record for the "I authorize recurring charges" consent
// gate (billing-contract.md leaves where consent is persisted to Lane 3).
// Kept alongside the best-effort consent_authorized fields sent in
// postPaymentStatus above so there is a durable local record even though
// invoice_router.py doesn't yet declare those fields.
export const recordSubscriptionConsent = (invoiceId) => {
  const record = { authorized: true, authorizedAt: new Date().toISOString() };
  try {
    window.localStorage.setItem(consentStorageKey(invoiceId), JSON.stringify(record));
  } catch {
    // localStorage unavailable (private browsing, etc.) — consent still gates the UI in-memory.
  }
  return record;
};
